import Vue from "vue";
import Router from "vue-router";
// import Home from "./views/Home.vue";
import Search from "./views/Search.vue";
import AuthCallback from "./views/AuthCallback.vue";
import LoggedOut from "./views/LoggedOut.vue";

import store from "./store/store";


Vue.use(Router);

export const router = new Router({
  // mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Search,
      meta: { requiresAuth: true }
    },
    {
      path: "/search",
      name: "search",
      component: Search,
      meta: { requiresAuth: true }
    },
    {
      path: "/stats",
      name: "stats",
      component: () =>
        import(/* webpackChunkName: "stats" */ "./views/Statistics.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/authCallback/:tmpToken",
      name: "authCallback",
      component: AuthCallback
    },
    {
      path: "/loggedOut",
      name: "loggedOut",
      component: LoggedOut
    }
  
  ]
});

router.beforeEach((to, from, next) => {

  let state = store;
  if (to.matched.some(record => record.meta.requiresAuth)) {
    
    if (!state.getters.loggedIn) {
      next({
        path: "/loggedOut",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});
